module.exports = __webpack_public_path__ + "media/images/riders/small/GREG_WILLIAMSON-dc688562cc5db544465c70ed08494491.png";